module.exports = __webpack_public_path__ + "img/golden-line@2x.9ee1bd35.png";